// Statuses that describe the user's own situation rather than a fault.
const EXPECTED_STATUSES = [401, 403, 422];

/**
 * @description Whether a failed response is an answer rather than a defect.
 *
 * A wrong password, an action the user's role does not allow and a form that did
 * not validate are all outcomes the system is supposed to produce. They are shown
 * to the user and not reported: Bugsnag is for what nobody expected, and these were
 * drowning it — the loudest group in the project was a permission denial.
 *
 * 404 stays reportable, because from here a resource that does not exist and an
 * endpoint that does not exist look the same.
 *
 * Lives apart from `./axios` for the same reason `./unauthorizedDecision` does —
 * importing that module registers the interceptors and pulls in the store and
 * router, and `responseErrorHandler` returns early under NODE_ENV=test, which
 * leaves this branch unreachable from a unit test. Pure, with no dependencies.
 * @param status HTTP status of the failed response
 * @returns {boolean}
 */
export const isExpectedOutcome = (status) => EXPECTED_STATUSES.includes(status);

export default isExpectedOutcome;
